var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6942 15.032C12.4675 15.1736 12.2125 15.2303 11.9858 15.2303C11.7591 15.2303 11.5041 15.1736 11.2774 15.032L0 8.14648V17.2988C0 19.2539 1.58678 20.8407 3.54191 20.8407H20.4581C22.4132 20.8407 24 19.2539 24 17.2988V8.14648L12.6942 15.032Z",
    fill: "#1D4650"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.458 3.16016H3.54185C1.87007 3.16016 0.453305 4.35024 0.113281 5.93702L12.0141 13.1909L23.8866 5.93702C23.5466 4.35024 22.1298 3.16016 20.458 3.16016Z",
    fill: "#1D4650"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.29aac3ef764bd38876dd2ff3e4e44b99.svg";
export { ForwardRef as ReactComponent };